import { render, staticRenderFns } from "./AdminBoardGantt.vue?vue&type=template&id=0906337c&scoped=true"
import script from "./AdminBoardGantt.vue?vue&type=script&lang=js"
export * from "./AdminBoardGantt.vue?vue&type=script&lang=js"
import style0 from "./AdminBoardGantt.vue?vue&type=style&index=0&id=0906337c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0906337c",
  null
  
)

export default component.exports